module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Meldung1.5122a34b.jpg";